export const AccountVerificationsScenario = {
  AIV: 1,
  FCA: 2,
};
